import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  refreshData: false,
  collectionMode: "Collection",
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    updateRefreshData: (state) => {
      state.refreshData = !state.refreshData;
    },

    updateCollectionMode: (state, action) => {
      state.collectionMode = action.payload;
    },
  },
});

export const { updateRefreshData, updateCollectionMode } = appSlice.actions;

export default appSlice.reducer;
